<template>
  <div class="ibi-investments-page">
    <dynamic-component-viewer
      :component-name="componentName"
      :analytics-prefix="analyticsPrefix"
    />
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapActions } from 'vuex';
import Segment from '@/Segment';
import DynamicComponentViewer from '@/components/DynamicComponentViewer.vue';
import consts from '@/store/utilities/constants';

export default {
  name: 'IBIContentPage',
  components: {
    DynamicComponentViewer,
  },
  data() {
    return {
      componentName: consts.DYNAMIC_COMPONENT_NAMES.IBI_PAGES,
      analyticsPrefix: 'IBIInvestmentsPage',
    };
  },
  created() {
    Segment.trackUserInteraction('IBIInvestmentsPage_Entered');
    this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.LIGHT_BLUE,
      textColor: BaseUI.Colors.riseupBlack,
      logoColor: BaseUI.Colors.riseupBlack,
      showLogo: true,
    });
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.ibi-investments-page {
  height: 100%;
  background: $riseup_light_blue;
  flex-grow: 1;

  .header {
    display: flex;
    justify-content: center;
    border-radius: 0px 0px 20px 20px;
    background-color: $riseup_light_blue;
  }
}
</style>
